//public enum FileCategory {
//    chargeback,
//    fraud,
//    appeal,
//    diff,
//    accessible,
//    export
// }
const fileCategorises = {
    chargeback: 'chargeback',
    fraud: 'fraud',
    appeal: 'appeal',
    diff: 'diff',
    accessible: 'accessible',
    export: 'export'
};

export const getFileCategory = (category) => {
    return fileCategorises[category];
};
